// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mg-0";
export var animationContainer = "_mg-1";
export var itemPrice = "_mg-a";
export var itemizedContent = "_mg-9";
export var itemizedHeader = "_mg-7";
export var itemizedRow = "_mg-8";
export var itemizedSection = "_mg-6";
export var modalContent = "_mg-2";
export var orderName = "_mg-3";
export var refundOption = "_mg-4";
export var refundOptionsContainer = "_mg-5";
export var shippingLabel = "_mg-b";
export var totalRow = "_mg-c";